import { lazy } from '@loadable/component'

// import { getEnvParam } from 'env'

export default function getRoutes(config) {
  const routes = [
    {
      path: '/migration',
      Component: lazy(() => import('pages/auth/migration'), config),
    },
    {
      path: '/masterPW/changePW',
      Component: lazy(() => import('pages/auth/changeMasterPW'), config),
    },
  ]

  return routes
}
